export const getRankEmoji = (rank) => {
  switch (rank) {
    case 1:
      return "🥇";
    case 2:
      return "🥈";
    case 3:
      return "🥉";
    case 4:
      return "🏅";
    case 5:
      return "🏅";
    case 6:
      return "🏅";
    default:
      return "🎖️"; // Default icon for other ranks
  }
};
